import { Helmet } from "fusion-plugin-react-helmet-async";
import { assetUrl } from "fusion-core";

const mainCss = assetUrl("../../styles/main.css");

const Loader = ({ text, blackbg = false }) => {
  const bgClass = blackbg ? "grayedOutBgFixed2 blackBg" : "grayedOutBgFixed2";
  return (
    <>
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
        />
        <link rel="stylesheet" href={mainCss} />
      </Helmet>
      <div className={bgClass}>
        <div className="progressBar">
          <div className="progressBarFill"></div>
        </div>
        <div className="progressText">{text}</div>
      </div>
    </>
  );
};

export default Loader;
